var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M876.1,771H711V549H313v222H147c-32,0-58-26-58-58V298c0-32,26-58,58-58h730c32,0,58,26,58,58v414.1   C935,744.6,908.6,771,876.1,771z M741,741h135.1c15.9,0,28.9-13,28.9-28.9V298c0-15.4-12.6-28-28-28H147c-15.4,0-28,12.6-28,28v415   c0,15.4,12.6,28,28,28h136V519h458V741z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741,270H283V121h458V270z M313,240h398v-89H313V240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741,903H283V519h458V903z M313,873h398V549H313V873z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 519,
    width: 543,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 717,
    y: 380,
    width: 66,
    height: 30
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 409,
    y: 642,
    width: 206,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409,
    y: 749,
    width: 136,
    height: 30
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.cac63d89656da046ad65e990570a5381.svg";
export { ForwardRef as ReactComponent };